import { splitSignature } from '@ethersproject/bytes';
import { BigNumber } from 'ethers';
import BaseService from '../commons/BaseService';
import { ProtocolAction } from '../commons/types';
import { API_ETH_MOCK_ADDRESS, gasLimitRecommendations } from '../commons/utils';
import { ERC20_2612Service } from '../erc20-2612';
import { ERC20Service } from '../erc20-contract';
import { SynthetixService } from '../synthetix-contract';
import { Pool, } from '../v3-pool-contract';
import { IPool__factory } from '../v3-pool-contract/typechain/IPool__factory';
import { WETHGatewayService } from '../wethgateway-contract';
export class PoolBundle extends BaseService {
    constructor(provider, lendingPoolConfig) {
        super(provider, IPool__factory);
        const { POOL, WETH_GATEWAY } = lendingPoolConfig !== null && lendingPoolConfig !== void 0 ? lendingPoolConfig : {};
        this.poolAddress = POOL !== null && POOL !== void 0 ? POOL : '';
        this.wethGatewayAddress = WETH_GATEWAY !== null && WETH_GATEWAY !== void 0 ? WETH_GATEWAY : '';
        this.v3PoolService = new Pool(provider, lendingPoolConfig);
        // initialize services
        this.erc20_2612Service = new ERC20_2612Service(provider);
        this.erc20Service = new ERC20Service(provider);
        this.synthetixService = new SynthetixService(provider);
        this.wethGatewayService = new WETHGatewayService(provider, this.erc20Service, WETH_GATEWAY);
        this.contractInterface = IPool__factory.createInterface();
        this.supplyTxBuilder = {
            getApprovedAmount: async (props) => {
                const spender = props.token.toLowerCase() === API_ETH_MOCK_ADDRESS.toLowerCase()
                    ? this.wethGatewayAddress
                    : this.poolAddress;
                const amount = await this.erc20Service.approvedAmount(Object.assign(Object.assign({}, props), { spender }));
                return Object.assign(Object.assign({}, props), { spender, amount: amount.toString() });
            },
            generateTxData: ({ user, reserve, amount, onBehalfOf, referralCode, }) => {
                let actionTx = {};
                const onBehalfOfParam = onBehalfOf !== null && onBehalfOf !== void 0 ? onBehalfOf : user;
                const referralCodeParam = referralCode !== null && referralCode !== void 0 ? referralCode : '0';
                if (reserve.toLowerCase() === API_ETH_MOCK_ADDRESS.toLowerCase()) {
                    actionTx = this.wethGatewayService.generateDepositEthTxData({
                        user,
                        amount,
                        onBehalfOf: onBehalfOfParam,
                        referralCode: referralCodeParam,
                    });
                }
                else {
                    const txData = this.contractInterface.encodeFunctionData('supply', [
                        reserve,
                        amount,
                        onBehalfOfParam,
                        referralCodeParam,
                    ]);
                    actionTx.to = this.poolAddress;
                    actionTx.from = user;
                    actionTx.data = txData;
                    actionTx.gasLimit = BigNumber.from(gasLimitRecommendations[ProtocolAction.supply].recommended);
                }
                return actionTx;
            },
            generateSignedTxData: ({ user, reserve, amount, onBehalfOf, referralCode, signature, deadline, }) => {
                const decomposedSignature = splitSignature(signature);
                const populatedTx = {};
                const onBehalfOfParam = onBehalfOf !== null && onBehalfOf !== void 0 ? onBehalfOf : user;
                const referralCodeParam = referralCode !== null && referralCode !== void 0 ? referralCode : '0';
                const txData = this.contractInterface.encodeFunctionData('supplyWithPermit', [
                    reserve,
                    amount,
                    onBehalfOfParam,
                    referralCodeParam,
                    deadline,
                    decomposedSignature.v,
                    decomposedSignature.r,
                    decomposedSignature.s,
                ]);
                populatedTx.to = this.poolAddress;
                populatedTx.from = user;
                populatedTx.data = txData;
                populatedTx.gasLimit = BigNumber.from(gasLimitRecommendations[ProtocolAction.supplyWithPermit].recommended);
                return populatedTx;
            },
        };
        this.borrowTxBuilder = {
            generateTxData: ({ user, reserve, amount, debtTokenAddress, onBehalfOf, referralCode, }) => {
                let actionTx = {};
                const referralCodeParam = referralCode !== null && referralCode !== void 0 ? referralCode : '0';
                const onBehalfOfParam = onBehalfOf !== null && onBehalfOf !== void 0 ? onBehalfOf : user;
                if (reserve.toLowerCase() === API_ETH_MOCK_ADDRESS.toLowerCase()) {
                    if (!debtTokenAddress) {
                        throw new Error(`To borrow ETH you need to pass the stable or variable WETH debt Token Address corresponding the interestRateMode`);
                    }
                    actionTx = this.wethGatewayService.generateBorrowEthTxData({
                        user,
                        amount,
                        debtTokenAddress,
                        referralCode: referralCodeParam,
                    });
                }
                else {
                    const txData = this.contractInterface.encodeFunctionData('borrow', [
                        reserve,
                        amount,
                        referralCodeParam,
                        onBehalfOfParam,
                    ]);
                    actionTx.to = this.poolAddress;
                    actionTx.from = user;
                    actionTx.data = txData;
                    actionTx.gasLimit = BigNumber.from(gasLimitRecommendations[ProtocolAction.borrow].recommended);
                }
                return actionTx;
            },
        };
    }
}
//# sourceMappingURL=index.js.map